/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminListingAnalytics,
    AdminListingAnalyticsFromJSON,
    AdminListingAnalyticsFromJSONTyped,
    AdminListingAnalyticsToJSON,
} from './AdminListingAnalytics';
import {
    AdminMarketPoint,
    AdminMarketPointFromJSON,
    AdminMarketPointFromJSONTyped,
    AdminMarketPointToJSON,
} from './AdminMarketPoint';
import {
    AdminMarketSnapshot,
    AdminMarketSnapshotFromJSON,
    AdminMarketSnapshotFromJSONTyped,
    AdminMarketSnapshotToJSON,
} from './AdminMarketSnapshot';
import {
    AdminPriceChange,
    AdminPriceChangeFromJSON,
    AdminPriceChangeFromJSONTyped,
    AdminPriceChangeToJSON,
} from './AdminPriceChange';

/**
 * 
 * @export
 * @interface AdminProductAnalyticsResp
 */
export interface AdminProductAnalyticsResp {
    /**
     * EbayMarket is the newest eBay market snapshot; null before the first one.
     * @type {AdminMarketSnapshot}
     * @memberof AdminProductAnalyticsResp
     */
    ebayMarket?: AdminMarketSnapshot;
    /**
     * 
     * @type {Array<AdminListingAnalytics>}
     * @memberof AdminProductAnalyticsResp
     */
    listings: Array<AdminListingAnalytics>;
    /**
     * 
     * @type {number}
     * @memberof AdminProductAnalyticsResp
     */
    lowestResalePrice: number;
    /**
     * last 180 days, oldest first
     * @type {Array<AdminMarketPoint>}
     * @memberof AdminProductAnalyticsResp
     */
    marketHistory: Array<AdminMarketPoint>;
    /**
     * 
     * @type {number}
     * @memberof AdminProductAnalyticsResp
     */
    msrp: number;
    /**
     * oldest first
     * @type {Array<AdminPriceChange>}
     * @memberof AdminProductAnalyticsResp
     */
    priceHistory: Array<AdminPriceChange>;
    /**
     * 
     * @type {number}
     * @memberof AdminProductAnalyticsResp
     */
    purchasePrice: number;
}

export function AdminProductAnalyticsRespFromJSON(json: any): AdminProductAnalyticsResp {
    return AdminProductAnalyticsRespFromJSONTyped(json, false);
}

export function AdminProductAnalyticsRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductAnalyticsResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ebayMarket': !exists(json, 'ebayMarket') ? undefined : AdminMarketSnapshotFromJSON(json['ebayMarket']),
        'listings': ((json['listings'] as Array<any>).map(AdminListingAnalyticsFromJSON)),
        'lowestResalePrice': json['lowestResalePrice'],
        'marketHistory': ((json['marketHistory'] as Array<any>).map(AdminMarketPointFromJSON)),
        'msrp': json['msrp'],
        'priceHistory': ((json['priceHistory'] as Array<any>).map(AdminPriceChangeFromJSON)),
        'purchasePrice': json['purchasePrice'],
    };
}

export function AdminProductAnalyticsRespToJSON(value?: AdminProductAnalyticsResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ebayMarket': AdminMarketSnapshotToJSON(value.ebayMarket),
        'listings': ((value.listings as Array<any>).map(AdminListingAnalyticsToJSON)),
        'lowestResalePrice': value.lowestResalePrice,
        'marketHistory': ((value.marketHistory as Array<any>).map(AdminMarketPointToJSON)),
        'msrp': value.msrp,
        'priceHistory': ((value.priceHistory as Array<any>).map(AdminPriceChangeToJSON)),
        'purchasePrice': value.purchasePrice,
    };
}

